import * as types from "../../actions/types";



const initialState = {
  data: null,
  tableData: null
}


export default function strength (state = initialState, action) {
  switch (action.type) {
      
    case types.SET_SETTINGS_STRENGTH_DATA:
      return {
        ...state,
        data: action.payload
      }
      
    case types.SET_SETTINGS_STRENGTH_TABLE_DATA:
      return {
        ...state,
        tableData: action.payload
      }

    default:
      return state;
  }
}